export default __webpack_public_path__ + "static/openSeaChatImg-5fa6d4bcf25e13ebadb81575dd53633a.png";